import { App, Button, Card, Col, Input, message,  Pagination, Row, Select, Space, Spin, Table, Tag, Popconfirm, Tooltip, } from "antd";
import { CheckOutlined, CloseOutlined, DeleteOutlined, EyeFilled, LoadingOutlined, } from "@ant-design/icons";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {  LIST_AZURE_CONFIG, AZURE_CONFIG_STATUS,DELETE_AZURE_CONFIG  } from "../../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../../components/CulsightPageLoader";
import { formatToIST } from "../../../../helper/CommonHelper";



function Microsoft() {
  const { notification } = App.useApp();
  const [page_size, set_page_size] = useState(10);
  //USE STATE FOR PAGINATION AND LOADER
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState(false);
  const [current_page, set_current_page] = useState("");
  const [total_pages, set_total_pages] = useState("");
  const [total_count, set_total_count] = useState("");
  const [onchange_call, set_onchange_call] = useState(true);
  
  // fillter state
  const [placeholder, set_placeholder] = useState("Search by Domain");
  const [search_query_key, set_search_query_key] = useState('Domain');
  const [search_query_value, set_search_query_value] = useState('');
 

  const fetchResults = useCallback((search_key, search_value) => {
    debounce(async () => {
      try {
        set_pagination_loader(true);
        const FORM_DATA = new FormData();
        FORM_DATA.append(search_key, search_value);
        const API_CALL = await LIST_AZURE_CONFIG(FORM_DATA);
        if (API_CALL?.data?.status) {
          set_table_data(API_CALL?.data?.data);
          set_current_page(API_CALL?.data?.current_page);
          set_total_pages(API_CALL?.data?.total_pages);
          set_total_count(API_CALL?.data?.total_count);
        }
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        set_pagination_loader(false);
      }
    }, 500)();
  }, []);



  const LIST_API = async () => {
    const FORM_DATA = new FormData();
    const API_CALL = await LIST_AZURE_CONFIG(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_count(API_CALL?.data?.total_count);
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  useEffect(() => {
    LIST_API();
  }, [onchange_call]);

  const change_status = async (id) => {
    setLoader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("id", id);
    try {
      const response = await AZURE_CONFIG_STATUS(FORM_DATA);
      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response?.data?.message,
        });
        set_onchange_call(onchange_call ? false : true)

      } else {
        // setLoader(false);

      }
    } catch (error) {
      message.error(
        "Server Error: " + (error?.response?.data?.message || "Unknown error")
      );
    }
  };

  const selectBefore = (
    <Select defaultValue="Domain" onChange={(value) => {
      if (value === 'domain') {
        set_search_query_key('domain')
        set_placeholder("Search by Domain");
        fetchResults('domain', search_query_value)
      }
    
    }}>
      <Select.Option value="domain">Domain</Select.Option>
     
    </Select>
  );

   const deleteMicrosoft = async (id) => {
      try {
        setLoader(true);
  
        const FD = new FormData();
        FD.append("id", id);
  
        const API = await DELETE_AZURE_CONFIG(FD);
  
        if (API?.data?.status) {
          notification.success({
            message: "Deleted",
            description: API?.data?.message,
          });
          LIST_API();
        }
      } catch (e) {
        notification.error({
          message: "Failed",
          description: "Deletion failed!",
        });
      } finally {
        setLoader(false);
      }
    };
  

  const columns = [
    {
      title: "Tenant ID",
      dataIndex: "tenant_id",
      render: (text, record) => (
        <span>
          {record.tenant_id}
        </span>
      ),
    },
    {
      title: "Client ID",
      dataIndex: "client_id",
      render: (text, record) => <span>{record.client_id}</span>,
    },
    {
      title: "Domain",
      dataIndex: "domain",
      render: (text, record) => <span>{record.domain}</span>,
    },
    
    {
      title: "Created On",
      key: "created_at",
      render: (text, record) => (
        <div>
          <div style={{ fontSize: "12px" }}>{formatToIST(record.created_at)}</div>

        </div>
      ),
    },
    {
      title: "Status",
      key: "status",
      render: (text, record) => (
        <span>
          {record.status ? (
            <>
              <Tag color="success">Active</Tag>
            </>
          ) : (
            <>
              <Tag color="error">Inactive</Tag>
            </>
          )}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button type="primary" size="small" onClick={() => navigate("/edit-microsoft/" + btoa(record.id))}><EyeFilled /></Button>
          

 <Popconfirm
  title="Do you want to change the status?"
  onConfirm={() => change_status(record?.id)}
  okText="Yes"
  cancelText="No"
>
  <Tooltip title="Change Status">
    <Button
      size="small"
      style={{
        backgroundColor: record.status ? "#52c41a" : "#ff4d4f",
        borderColor: record.status ? "#52c41a" : "#ff4d4f",
        color: "#fff"
      }}
      icon={
        record.status ? (
          <CheckOutlined />
        ) : (
          <CloseOutlined />
        )
      }
    />
  </Tooltip>
</Popconfirm>

          <Popconfirm
            title="Are you sure you want to delete?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => deleteMicrosoft(record?.id)}
          >
            <Button danger size="small" type="primary">
              <DeleteOutlined />
            </Button>
          </Popconfirm>

        </Space>
      ),
    },
  ];

  const pagination_on_change = async (page, size) => {
    set_pagination_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("page", page);
    FORM_DATA.append("per_page", size);
    FORM_DATA.append(search_query_key, search_query_value);
    const API_CALL = await LIST_AZURE_CONFIG(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_count(API_CALL?.data?.total_count);
      set_pagination_loader(false);
    } else {
      set_pagination_loader(false);
    }
  }

  const handleInput = (e) => {
    const value = e.target.value;
    set_search_query_value(value)

    if (search_query_key === 'domain') {
      fetchResults('domain', value)
    }
  
  };


  

  return (
    <div className="lms-body">
      <Card>
        <Row>
          <Col span={12}>
            <h2>Microsoft</h2>
          </Col>
          <Col span={12}>
            <div className="learner-buttons" style={{ float: "right" }}>
             
              <Button
                color="green"
                variant="solid"
                style={{ marginRight: "10px" }}
                onClick={() => navigate("/add-microsoft")}
              >
                Add Microsoft
              </Button>
             
             
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Input
              addonBefore={selectBefore}
              placeholder={placeholder}
              onChange={handleInput}
              size="large"
            />
          </Col>
        </Row>

        {loader ? (
          <>
            <CulsightPageLoader />
          </>
        ) : (
          <>
            {pagination_loader ? (
              <>
                <div style={{ textAlign: "center", padding: "60px" }}>
                  <Spin indicator={<LoadingOutlined spin />} size="large" />
                </div>
              </>
            ) : (
              <>
                <Table
                  columns={columns}
                  pagination={false}
                  dataSource={table_data}
                  style={{ marginTop: "15px" }}
                  rowKey="id"
                />
              </>
            )}

            {total_pages > 0 ? (
              <>
                <div style={{ float: "right", marginTop: "20px" }}>
                  {" "}
                  <Pagination
                    current={current_page}
                    total={total_count}
                    pageSize={page_size}
                    showSizeChanger
                    pageSizeOptions={['10', '20', '50', '100']}
                    onChange={(page) => pagination_on_change(page, page_size)}
                    onShowSizeChange={(page, size) => {
                      set_page_size(size);
                      pagination_on_change(1, size);
                    }}
                    style={{ display: 'inline-block' }}
                    className="no-search-pagination"
                  />

                  <style>
                    {`
    .no-search-pagination .ant-select-selection-search-input {
      display: none !important;
    }
  `}
                  </style>
                </div>
              </>
            ) : (
              <>
                
              </>
            )}
          </>
        )}



        
    


      </Card>
    </div>
  );
}

export default Microsoft;
